import React from "react";
import { RoundedSelect } from "ui/roundedSelect/RoundedSelect";
import { Box, MenuItem, makeStyles } from "@material-ui/core";
import { SubcategoriesStaticData } from "data/categories";
import { capitalize } from "helpers/algoliaUtils";
import { FontSizeProperty } from "@material-ui/styles/node_modules/csstype/index";

interface DropdownListProps {
  items;
  defaultRefinement: string;
  refine: (item: any) => void;
  scrollToTop: () => void;
  isCategoryDropdown?: boolean;
  fontSize?: FontSizeProperty<string | 0>;
}

const DropdownList: React.FC<DropdownListProps> = ({
  items,
  refine,
  defaultRefinement,
  scrollToTop,
  isCategoryDropdown = false,
  fontSize = "18px",
}) => {
  const classes = useStyles({ isCategoryDropdown, fontSize });

  return (
    <Box zIndex={1}>
      <RoundedSelect
        classes={classes}
        fullWidth
        value={items?.find((item) => item.isRefined)?.value || defaultRefinement}
        placeholder={undefined}
      >
        {items &&
          items.map((item) => (
            <MenuItem
              key={item.value}
              value={item.value}
              style={{
                fontWeight: item.isRefined ? "bold" : "normal",
                display: item.label === "Trier" || item.label.startsWith("Voir ") ? "none" : "",
              }}
              onClick={(event) => {
                event.preventDefault();
                refine(item.value);
                scrollToTop();
              }}
            >
              {isCategoryDropdown
                ? SubcategoriesStaticData.find((cat) => cat.slug === item.label)?.name || capitalize(item.label)
                : item.label}
            </MenuItem>
          ))}
      </RoundedSelect>
    </Box>
  );
};

const useStyles = makeStyles((theme) => ({
  select: {
    color: (props: { isCategoryDropdown: boolean; fontSize: FontSizeProperty<string | 0> }) =>
      props.isCategoryDropdown ? theme.palette.black500.main : theme.palette.secondary.dark,
    border: "unset",
    boxShadow: "none",
    "& > svg": {},
    "& > fieldset": {
      border: "none",
    },
    "&:hover": {
      backgroundColor: "none",
      "& > fieldset": {
        borderColor: "none",
      },
      textDecoration: (props: { isCategoryDropdown: boolean; fontSize: FontSizeProperty<string | 0> }) =>
        props.isCategoryDropdown ? "underline" : "none",
    },
    "&:focus": {
      backgroundColor: "white",
    },
  },
  root: {
    fontSize: (props: { isCategoryDropdown: boolean; fontSize: FontSizeProperty<string | 0> }) =>
      props.fontSize || "18px",
    "& > .MuiSelect-icon": {
      color: theme.palette.secondary.dark,
    },
    "& > fieldset": {
      border: "unset",
    },
  },
  focused: {
    boxShadow: "none",
    "& > fieldset": {
      border: "none",
    },
  },
  focus: {
    backgroundColor: "#ffffff",
  },
  menuListItem: {
    height: theme.spacing(5),
    fontSize: (props: { isCategoryDropdown: boolean; fontSize: FontSizeProperty<string | 0> }) =>
      props.fontSize || "18px",
  },
  popover: {
    "& > .MuiPaper-root": {
      borderRadius: 5,
      boxShadow: "0px 0px 34px rgba(0, 0, 0, 0.1)",
    },
  },
}));

export default DropdownList;
